import apiService from "./apiService";
import AppConstants from "../appConstants";

class ContentPrivateConfigService {
    getAllContentPrivateConfig(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT_PRIVATE_CONFIG, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getContentPrivateConfigDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CONTENT_PRIVATE_CONFIG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerContentPrivateConfig(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CONTENT_PRIVATE_CONFIG, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteContentPrivateConfig(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CONTENT_PRIVATE_CONFIG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CONTENT_PRIVATE_CONFIG_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateApiCache(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT_PRIVATE_CONFIG_UPDATE_API_CACHE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new ContentPrivateConfigService();
